import dayjs from 'dayjs'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useNavigate, useParams } from 'react-router-dom'
import { treinamentos } from 'service/api'
import { toast } from 'sonner'
import { useTreinamentosOutletContext } from 'templates/Admin/Clientes/atoms/Pages/Cobrancas'

export default function ExcluirTreinamento() {
    const navigate = useNavigate()
    const { id } = useParams()
    const { data, clienteId } = useTreinamentosOutletContext()
    const treinamento = data.find(item => item.id === Number(id))

    const { mutateAsync, isLoading } = treinamentos.mutations.useDelete({
        invalidateQuery: true,
        queryParams: { clienteId: String(clienteId) },
    })

    if (!treinamento) return null

    const handleSubmit = () =>
        mutateAsync(treinamento.id, {
            onSuccess: () => {
                toast.success('Treinamento excluído com sucesso!')
                navigate(-1)
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <Dialog.Root
            width="auto"
            height="auto"
            loading={isLoading}
            onSubmit={handleSubmit}
            open={hasPermission(['delete', 'Treinamentos'])}
        >
            <Dialog.Content>
                Realmente deseja excluir o treinamento de{' '}
                {dayjs(treinamento.data).format('DD/MM/YYYY HH:mm')} recebido
                por {treinamento.quemRecebeu}?
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit color="error">
                    Excluir
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
